<div class="page-padding footer-padding bg-color footer">
  <div class="row row-wrap footer__wrapper">
    <div class="footer__menu">
      <a [routerLink]="['/create']" class="anchor">
        {{ "shared.header.create_cv" | translate }}
      </a>
      <a
        *ngIf="!isLoggedIn"
        routerLinkActive="anchor-active"
        class="anchor"
        (click)="login.emit()"
        >
        {{ "shared.header.login" | translate }}
      </a>
    </div>

    <label class="footer__title txt-c-pink txt-transform-capital">
      {{ "footer.hohr" | translate }}
    </label>

    <address class="footer__address">
      <div>{{ "footer.street_number" | translate }}</div>
      <div>{{ "footer.zip_city" | translate }}</div>
      <div>{{ "footer.belgium" | translate }}</div>
    </address>

    <div class="footer__phone">
      <div>{{ "footer.phoneNumber" | translate }}</div>
      <div>{{ "footer.fax" | translate }}</div>
    </div>

    <div class="footer__logo-wrapper">
      <img class="footer__logo" src="assets/icons/hohr_logo.svg" />
    </div>
  </div>
</div>
